// POLYFILLS
import "../resources/polyfills";
import "../css/login.scss";

import Login from "./login";

// INSTANTIATE MAIN CLASS
export default new Login();